module.exports = __webpack_public_path__ + "static/media/nonfig.ad5dce54.jpg";